<template>
  <div class="container" :class="[seasonClass, tvClass, groupClass]">
    <div class="screen" :style="pageStyle">
      <template v-if="seasonClass === 'season1'">
        <img class="logo1" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_welcom_logo1.png" alt="">
        <img class="logo2" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_welcom_logo2.png" alt="">
        <img class="content" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_welcom_vision.png" alt="">
      </template>
      <template v-if="seasonClass === 'season2'">
        <div class="flex-box">
          <!-- <img class="qr" @click="toFullOrExit" :src="'https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/' + (districtId === '9' ? 'left-photo-huabei' : 'left-photo') + '.jpg'" alt=""> -->
          <img class="qr" @click="toFullOrExit" :src="'https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/left-wechat.jpg'" alt="">
          <div class="main-img">
            <img class="season2-logo1" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/spbcn-cebsb.png" alt="">
            <img class="season2-logo2" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/season4-logo1.png" alt="">
            <img class="season2-logo3" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/wzdlsj.png" alt="">
          </div>
          <!-- <img class="main-img" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/welcome.png" alt=""> -->
          <img class="qr" @click="toFullOrExit" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/right.jpg" alt="">
        </div>
      </template>
      <img src="../../../assets/img/fs.png" class="fullscreen" @click="toFullOrExit" alt="">
      <img src="../../../assets/img/fs.png" v-if="query.group === '1'" class="fullscreen-top" @click="toFullOrExit" alt="">
      <div class="load-font">
        <div class="font1">load font</div>
        <div class="font2">load font</div>
        <div class="font3">load font</div>
      </div>
    </div>
  </div>
</template>
<script>
import { sendWebsocket, closeWebsocket } from '../../../utils/ws'
export default {
  data () {
    return {
      seasonClass: '',
      groupClass: '',
      tvClass: '',
      screenWidth: 0,
      screenHeight: 0,
      pageStyle: {
        width: '100%'
      },
      scale: '',
      query: {},
      timer: null,
      matchTng: '', // 比赛状态 0-未开始 1-进行中 2-已结束
      districtId: ''
    }
  },
  mounted () {
    this.getScreenSize()
    window.addEventListener('resize', this.getScreenSize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getScreenSize)
    // closeWebsocket()
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  created () {
    document.title = '汉英双拼大会'
    const query = this.$route.query
    this.query = query
    this.districtId = query.districtId
    if (query.season === '2022~2023') {
      this.seasonClass = 'season1'
    } else if (query.season === '2023~2024') {
      this.seasonClass = 'season2'
    } else {
      this.seasonClass = 'season2'
    }
    if (query.TV) {
      this.groupClass = ''
    } else {
      this.groupClass = 'group' + query.group
    }
    this.tvClass = query.TV
    this.getMatchStart()
    // 确保在组件销毁前清理定时器
    if (this.timer) {
      clearInterval(this.timer)
    }
    this.timer = setInterval(() => {
      // 检查组件是否还存在
      if (this.$el && !this.$el.parentNode) {
        clearInterval(this.timer)
        return
      }
      this.getMatchStart()
    }, 3000)
    // this.requstWs()
  },
  methods: {
    // ws连接成功，后台返回的ws数据，组件要拿数据渲染页面等操作
    wsMessage (data) {
      const dataJson = data
      console.log(dataJson)
      // 这里写拿到数据后的业务代码
    },
    // ws连接失败，组件要执行的代码
    wsError () {
      // 比如取消页面的loading
    },
    requstWs () {
      // 防止用户多次连续点击发起请求，所以要先关闭上次的ws请求。
      closeWebsocket()
      // 跟后端协商，需要什么参数数据给后台
      // 传送的数据
      const obj = {
        // monitorUrl: '666',
        // userName: 'liming'
      }
      // 发起ws请求
      sendWebsocket('ws://192.168.2.53:9866/erp_dev/websocket/1', obj, this.wsMessage, this.wsError)
    },

    getScreenSize () {
      // const w = window.innerWidth // 屏幕宽
      const h = window.innerHeight // 屏幕高
      // 1920/1080
      const calcWidth = 1920 * h / 1080
      // console.log(calcWidth, w)
      // if (calcWidth < w) {
      if (this.seasonClass === 'season1') {
        this.pageStyle.width = parseInt(calcWidth) + 'px'
      }
      // } else {
      //   this.pageStyle.width = '100%'
      // }
    },
    requestFullScreen () {
      const de = document.documentElement
      if (de.requestFullscreen) {
        de.requestFullscreen()
      } else if (de.mozRequestFullScreen) {
        de.mozRequestFullScreen()
      } else if (de.webkitRequestFullScreen) {
        de.webkitRequestFullScreen()
      }
    },
    exitFullscreen () {
      const de = document
      if (de.exitFullscreen) {
        de.exitFullscreen()
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen()
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen()
      }
    },
    toFullOrExit () {
      this.isFull = !this.isFull
      if (this.isFull) {
        // this.fullImg = require('@/assets/img/efs.png')
        this.requestFullScreen()
      } else {
        // this.fullImg = require('@/assets/img/fs.png')
        this.exitFullscreen()
      }
    },
    // 查询考试开始状态
    getMatchStart () {
      if (this.query.round2026 === '1') {
        this.getRound1MatchStart()
      } else {
        this.getMatchStartOtherRound()
      }
    },
    getRound1MatchStart () {
      this.$http.get('examinationUser/getProgress?id=' + this.query.examinationRoomId, { showLoading: false }).then(res => {
        if (res.code === 200) {
          if (res.data) {
            if (res.data.matchEndType === 2) {
              // 结束
              this.$message.warning('比赛已结束')
              // this.savePaper()
            } else if (res.data.questionId) {
              this.$router.push('/padSemiQuiz?roomId=' + this.query.examinationRoomId)
            }
          }
        }
      })
    },
    getMatchStartOtherRound () {
      console.log('获取考场状态')
      const params = {
        activityType: this.query.activityType,
        season: this.query.season,
        isGroup: this.query.group,
        raceSchedule: this.query.raceSchedule,
        round: this.query.round,
        phase: this.query.phase,
        examinationRoomId: this.query.examinationRoomId
      }
      console.log('Number(params.isGroup)', Number(params.isGroup))
      if (Number(params.isGroup) === 1) {
        params.level = this.query.level
      }
      console.log('params============', params)
      this.$http.get('slabForm/queryNationalGroupFormInfoList', { params, showLoading: false }).then(res => {
        if (res.code === 200) {
          // 获取到题目：跳转到答题(erp点击了小题开始答题)
          if (res.data.groupFormInfo && res.data.groupFormInfo.quizIng === 1 && res.data.groupFormInfo.isDiscard !== 1) {
            this.nextPage()
          }
          // 开始比赛：提示比赛开始（erp点击了比赛开始）
          const matchTng = res.data.matchTng
          this.matchTng = matchTng
          if (matchTng === 1) { // 比赛开始
            this.matchStart = true
          }
          if (matchTng === 2) {
            clearInterval(this.timer)
          }
        }
      }).catch(err => {
        console.log('获取考场状态失败:', err)
        // 静默处理错误，避免影响用户体验
      })
    },
    nextPage () {
      if (this.query.raceSchedule === '2') {
        this.$router.push(`/pad/semiScreen?${this.$xcUtils.serialize(this.query)}`)
      } else {
        this.$router.push(`/pad/screen?${this.$xcUtils.serialize(this.query)}`)
      }
    }
  }
}
</script>
<style scoped lang="less">
.container{
  width: 100vw;
  height: 100vh;
}
.screen{
  // width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  color: #000;
  font-family: 'regular';
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
.season1{
  background-color: #B81C25;
  .screen{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_rankbg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}
.season2{
      background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/season4bg.jpg);

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  .flex-box{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-x: hidden;
    overflow-y: hidden;
  }
  .qr{
    width: auto;
    height: 100%;
  }
}

.main-img{
  flex: 1;
  height: 100%;
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/welcome-nologo.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  img{
    position: absolute;
  }
  .season2-logo1{
    top: 40px;
    left: 30px;
    height: 50px;
  }
  .season2-logo2{
    top: 40px;
    right: 30px;
    height: 50px;
  }
  .season2-logo3{
    bottom: 40px;
    right: 30px;
    height: 72px;
  }
}

.logo1{
  position: absolute;
  left: 60px;
  top: 50px;
  width: auto;
  height: 67px;
}
.logo2{
  position: absolute;
  right: 120px;
  top: 50px;
  width: auto;
  height: 70px;
}
.content{
  width: 80%;
}
.fullscreen{
  width: 32px;
  height: 32px;
  position: fixed;
  left: 10px;
  bottom: 10px;
  cursor: pointer;
}
.fullscreen-top{
  width: 32px;
  height: 32px;
  position: fixed;
  left: 10px;
  top: 10px;
  cursor: pointer;
}
.load-font {
  position: fixed;
  right: -1000px;
  bottom: 0;
  font-size: 20px;
}
.font1{
  font-family: fzcsk;
}
.font2{
  font-family: regular;
}
.font3{
  font-family: shufa;
}
// 小组赛适配5.5米*2.5米大屏
.season2.group1{
  // .main-img{
  //   img{
  //     position: absolute;
  //     // top: 30px;
  //   }
  //   .season2-logo1{
  //     left: 20px;
  //     height: 30px;
  //   }
  //   .season2-logo2{
  //     right: 20px;
  //     height: 40px;
  //   }
  // }
}

// 适配电视
.season2.TV {
  .qr{
    display: none;
  }
}
</style>
